import { SceneId } from "../../../shared/enum";
import { DefaultInfoMenu } from "./info-menu";
import getDecorators from "inversify-inject-decorators";
import container from "../../../ioc/inversify.config";

const { lazyInject } = getDecorators(container);

export class InfoLayerScene extends Phaser.Scene {
    private infoMenu;

    constructor() {
        super({ key: SceneId.INFO_LAYER_SCENE });
    }

    preload() {}

    init(gameState) {}

    public create(sceneId: string) {
        //        console.log('info layer scene creation');
        this.infoMenu = new DefaultInfoMenu(this);
        this.infoMenu.bindEvents();
        this.infoMenu.draw();

        // when the scene receives wake event
        //        this.sys.events.on('wake', this.refresh, this);

        //        this.refresh();
    }
}
